import { be4feMy2nApi } from './be4feMy2nApi';

const enhancedMy2nApi = be4feMy2nApi
  .enhanceEndpoints({
    addTagTypes: ['MobileVideoPriceInfo'],
    endpoints: {
      getMobileVideoPriceInfoMy2N: {
        providesTags: ['MobileVideoPriceInfo'],
      },
    },
  })
  .injectEndpoints({
    endpoints: (build) => ({
      processPaymentMy2N: build.mutation({
        query: (queryArg) => ({
          method: 'POST',
          params: queryArg.params,
          url: `/companies/${queryArg.companyId}/orders/${queryArg.orderId}/payments/${queryArg.paymentId}`,
        }),
      }),
    }),
    overrideExisting: true,
  });

export const { useProcessPaymentMy2NMutation } = enhancedMy2nApi;
